import classNames from 'classnames';
import React from 'react';
import {twMerge} from 'tailwind-merge';

interface Props {
    price: number;
    highlighted?: boolean;
    perks: string[];
    trialLength?: number;
    name: string;
    mainPerk?: string;
}

const PricingCard: React.FC<React.PropsWithChildren<Props>> = ({
    price,
    highlighted,
    perks,
    trialLength,
    name,
    mainPerk,
    children,
}) => {
    return (
        <div className="flex flex-col items-center justify-center gap-4">
            <div
                className={classNames(
                    'border-1 mx-0 flex h-[245px] w-[400px] flex-col items-start rounded-[21px] border border-solid bg-[#fefefe] px-5 pb-5 pt-3 text-[#453333]',
                    highlighted &&
                        'border-transparent shadow-[0px_0px_0px_2px_#ffc070,0px_0px_0px_4px_#fff06e,0px_0px_0px_6px_#ff7670]',
                    !highlighted && 'border-[#ECECEC]'
                )}
            >
                <div
                    className={twMerge(
                        'flex flex-row items-start justify-between self-stretch',
                        trialLength ? 'mb-3' : 'mb-6'
                    )}
                >
                    <h1 className="font-['Inter'] text-2xl font-bold">{name}</h1>
                    <div className="flex flex-col">
                        <h2 className="font-['Inter'] text-2xl">{price > 0 ? `$${price}/month` : 'Free'}</h2>
                        {trialLength && (
                            <div className="self-end whitespace-nowrap text-center font-['Inter'] text-xs font-bold">
                                {trialLength} day free trial
                            </div>
                        )}
                    </div>
                </div>
                <div className="ml-3 max-w-full font-['Inter'] text-sm font-medium">
                    <ol>
                        {perks.map((perk) => (
                            <li key={perk} className="list-disc font-['Inter'] text-sm font-medium">
                                {perk}
                            </li>
                        ))}
                    </ol>
                </div>
                {mainPerk && <div className="mt-auto font-['Inter'] text-2xl">{mainPerk}</div>}
            </div>
            {children}
        </div>
    );
};

export default PricingCard;
